var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Auth } from 'aws-amplify';
import { call, put, takeEvery } from 'redux-saga/effects';
import { LOGIN_USER, loginError, loginSuccess, loginWithCompleteNewPassword, } from '../../actions';
var loginAsync = function (email, password) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, Auth.signIn({ username: email, password: password })];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
function login(_a) {
    var email, password, history, loginUser, error_1;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                email = payload.email, password = payload.password, history = payload.history;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 11, , 15]);
                return [4 /*yield*/, call(loginAsync, email, password)];
            case 2:
                loginUser = _b.sent();
                if (!!loginUser) return [3 /*break*/, 4];
                return [4 /*yield*/, put(loginError(loginUser.message))];
            case 3:
                _b.sent();
                return [2 /*return*/];
            case 4:
                if (!(loginUser.code === 'NotAuthorizedException')) return [3 /*break*/, 6];
                return [4 /*yield*/, put(loginError(loginUser.message))];
            case 5:
                _b.sent();
                return [2 /*return*/];
            case 6:
                if (!(loginUser.challengeName === 'NEW_PASSWORD_REQUIRED')) return [3 /*break*/, 8];
                return [4 /*yield*/, put(loginWithCompleteNewPassword(loginUser))];
            case 7:
                _b.sent();
                history.push('/user/complete-new-password');
                return [2 /*return*/];
            case 8: return [4 /*yield*/, put(loginSuccess())];
            case 9:
                _b.sent();
                return [4 /*yield*/, history.push('/app')];
            case 10:
                _b.sent();
                return [3 /*break*/, 15];
            case 11:
                error_1 = _b.sent();
                if (!error_1.message.includes('Temporary password')) return [3 /*break*/, 13];
                return [4 /*yield*/, put(loginError('Senha temporária expirada! Entre em contato com a gente pelo e-mail faleconosco@tratum.com.br'))];
            case 12:
                _b.sent();
                return [2 /*return*/];
            case 13: return [4 /*yield*/, put(loginError('E-mail ou senha invalido!'))];
            case 14:
                _b.sent();
                return [3 /*break*/, 15];
            case 15: return [2 /*return*/];
        }
    });
}
export function watchLogin() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(LOGIN_USER, login)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
